module.exports = __webpack_public_path__ + "static/media/revenueNormal.87efdad0.svg";